import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as why from "./style.module.scss";
export const Why = () => {
  return (
    <section className={why.why}>
      <div className="container">
        <h2 className={`${main.blockTitle} ${main.blockTitleMdM} ${why.whyTitle}`}>
          Почему выбирают нас?
        </h2>

        <div className={why.why_inner}>
          <div className="row">

            <div className={`col col-3 ${why.why_innerItem}`}>
              <div className={why.why_innerItem_icon}>
                <div className={why.why_icon}>
                  <img src="https://fs.advance.ru/landing-pages/online/smart/04-75000.svg" alt="Доверие"/>
                </div>
              </div>
              <p className={why.why_innerItem_text}>
                <span className={why.why_innerItem_desc}>
                  Более 75&nbsp;000&nbsp;человек
                </span>
                доверили нам повышение <br/>
                своей эффективности
                и&nbsp;интеллектуальной
                выносливости
              </p>
            </div>

            <div className={`col col-3 ${why.why_innerItem}`}>
              <div className={why.why_innerItem_icon}>
                <div className={why.why_icon}>
                  <img src="https://fs.advance.ru/landing-pages/online/smart/04-10let.svg" alt="Опыт"/>
                </div>
              </div>
              <p className={why.why_innerItem_text}>
                <span className={why.why_innerItem_desc}>
                  Более 10&nbsp;лет опыта
                </span>
                в&nbsp;разработке технологий
                личной эффективности человека
              </p>
            </div>

            <div className={`col col-3 ${why.why_innerItem}`}>
              <div className={why.why_innerItem_icon}>
                <div className={why.why_icon}>
                  <img src="https://fs.advance.ru/landing-pages/online/smart/04-avtor.svg" alt="Технологии"/>
                </div>
              </div>
              <p className={why.why_innerItem_text}>
                <span className={why.why_innerItem_desc}>
                  Авторские технологии
                </span>
                работы с&nbsp;информацией,
                проверенные временем
              </p>
            </div>

            <div className={`col col-3 ${why.why_innerItem}`}>
              <div className={why.why_innerItem_icon}>
                <div className={why.why_icon}>
                  <img src="https://fs.advance.ru/landing-pages/online/smart/04-practice.svg" alt="Практика"/>
                </div>
              </div>
              <p className={why.why_innerItem_text}>
                <span className={why.why_innerItem_desc}>
                  Практика
                </span>
                главный акцент на&nbsp;курсах
              </p>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};
